export const newsArticles = [
  {
    id: 1,
    title: '《禁止的爱善良的小姨子》收官周收视走高，结局片段引发集中讨论',
    date: '2026-10-16',
    category: '剧集动态',
    summary: '播出平台公布收官周数据，大结局单集播放量较开播周增长近一倍，门后那句手写字成为讨论焦点。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20still%20of%20an%20old%20Chinese%20courtyard%20door%20slightly%20open%20in%20early%20spring%20light%2C%20deep%20crimson%20door%20frame%2C%20ivory%20stone%20wall%2C%20delicate%20green%20leaves%2C%20warm%20hopeful%20atmosphere%2C%20elegant%20editorial%20film%20photography%2C%20no%20text%2C%20refined%20minimal%20composition&width=900&height=560&seq=news-01-finale&orientation=landscape',
    paragraphs: [
      '《禁止的爱善良的小姨子》本周迎来收官。播出平台公布的数据显示，大结局单集播放量较开播周增长近一倍，相关话题连续三天出现在讨论榜前列。',
      '引发讨论最多的是最后一场没有台词的戏：顾老爷子坐在廊下，小满在院子里种树，镜头最后停在门后那行手写字上。有观众认为这是全剧最轻的一场戏，也有人觉得它把前面十一集的压抑一次性放下了。',
      '编剧在采访中表示，结局从一开始就没有打算给出谁对谁错的答案。「这个家里的每个人都在做自己认为正确的事，问题在于这些正确的事加在一起，会伤人。」',
      '制作方透露，完整幕后特辑将在下月上线，包含主创围读、老宅实景搭建过程以及部分未采用片段。',
    ],
    tags: ['收官', '收视', '结局解读'],
  },
  {
    id: 2,
    title: '沈知微谈林小满：最难的不是哭戏，是忍住不哭',
    date: '2026-10-13',
    category: '演员访谈',
    summary: '主演沈知微分享拍摄期间的角色笔记，谈到与陆沉舟在雨夜长廊那场戏的拍摄细节。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20interview%20scene%20with%20a%20young%20East%20Asian%20actress%20holding%20a%20script%20in%20a%20softly%20lit%20old%20villa%20room%2C%20ivory%20walls%20and%20deep%20red%20curtains%2C%20warm%20lamp%20light%2C%20editorial%20film%20photography%2C%20no%20text%2C%20intimate%20quiet%20atmosphere&width=900&height=560&seq=news-02-interview&orientation=landscape',
    paragraphs: [
      '在剧中饰演林小满的沈知微，最近一次采访中带来了她为角色准备的三本笔记。本子里记的不是台词，而是每一天小满「没有说出口的话」。',
      '她提到第六集的雨夜长廊是全剧最难的一场：「导演要求我们把情绪压到最低，只要一个眼神。我练了很多次，最后发现真正难的是忍住不哭，因为小满在这个家已经学会不轻易示弱。」',
      '谈到与陆沉舟的合作，她说两人在开机前专门去了一趟老宅采风，「我们需要知道这个房子里哪些地方是会发出声音的，走路的节奏会影响表演。」',
      '沈知微透露，杀青那天她带走了一件戏服，就是小满回到顾家时穿的那件旧毛衣。',
    ],
    tags: ['沈知微', '幕后', '角色解读'],
  },
  {
    id: 3,
    title: '老宅不是布景：剧组用四个月搭出一座可以住人的院子',
    date: '2026-10-08',
    category: '幕后制作',
    summary: '美术指导详解顾家老宅的搭建逻辑，从青石台阶到厨房灶台，每一处都按真实生活尺度还原。',
    image: 'https://readdy.ai/api/search-image?query=Detailed%20cinematic%20view%20of%20a%20traditional%20Chinese%20courtyard%20house%20set%20under%20construction%20with%20wooden%20beams%2C%20craftsmen%20tools%2C%20warm%20afternoon%20light%2C%20deep%20crimson%20painted%20door%2C%20ivory%20walls%2C%20editorial%20documentary%20photography%2C%20no%20text%2C%20textured%20authentic%20atmosphere&width=900&height=560&seq=news-03-set&orientation=landscape',
    paragraphs: [
      '顾家老宅是全剧最重要的「角色」之一。美术指导介绍，这座院子并非借用现成古建，而是用四个月时间在影视基地内从零搭建。',
      '「我们不希望它看起来像展厅。」他提到，剧组特意保留了厨房被油烟熏过的墙、楼梯扶手被摸亮的痕迹，以及院子里一块始终没有修平的石板，「人会记得这些不完美的地方。」',
      '为了拍摄不同季节的同一场景，院中那棵树的枝叶被分三次更换。最后一场戏里小满种下的树，是真的树苗，拍完后被移栽到了基地外。',
      '老宅的客厅灯也是重要道具。美术组为它设计了七个亮度档位，从第一集到第十二集，灯光逐渐变亮，呼应这个家从封闭走向敞开。',
    ],
    tags: ['美术', '场景', '幕后'],
  },
  {
    id: 4,
    title: '陆沉舟：顾长川不是反派，他只是太早学会了闭嘴',
    date: '2026-09-30',
    category: '演员访谈',
    summary: '陆沉舟回应观众对顾长川的争议，认为这个角色的困境在于「把责任当成了不沟通的理由」。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20thoughtful%20East%20Asian%20actor%20sitting%20in%20an%20old%20study%20with%20bookshelves%2C%20warm%20amber%20desk%20lamp%2C%20deep%20burgundy%20armchair%2C%20ivory%20walls%2C%20editorial%20interview%20photography%2C%20no%20text%2C%20quiet%20intellectual%20mood&width=900&height=560&seq=news-04-lu&orientation=landscape',
    paragraphs: [
      '随着剧情推进，顾长川成为观众讨论最多的角色之一。有人觉得他过于冷硬，也有人认为他是全剧最累的人。',
      '陆沉舟在采访中说，他从不把这个角色当成反派来演。「顾长川的问题不是坏，而是他太早学会了闭嘴。他十六岁那年家里出事，从那以后他就相信，只要自己不说，事情就不会更糟。」',
      '他提到第十集医院走廊那场戏拍了整整一夜，「那场戏里他终于承认自己也会害怕。这句台词我们试了七种说法，最后用的是最轻的那一版。」',
      '谈到观众的评价，他笑说：「能被讨论就是好事，说明大家真的把这个家当成了一个真实存在的地方。」',
    ],
    tags: ['陆沉舟', '角色争议', '访谈'],
  },
  {
    id: 5,
    title: '编剧谈「禁止的爱」：写的不是越界，是边界内的沉默',
    date: '2026-09-22',
    category: '主创发声',
    summary: '编剧回应剧名带来的联想，强调故事核心是一个家庭如何在隐瞒中逐渐失去彼此。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20desk%20scene%20with%20handwritten%20scripts%20and%20a%20fountain%20pen%20under%20warm%20lamp%20light%2C%20ivory%20paper%20stacks%2C%20deep%20crimson%20notebook%2C%20dark%20wood%20table%2C%20editorial%20still%20life%20photography%2C%20no%20text%2C%20intimate%20writer%20atmosphere&width=900&height=560&seq=news-05-writer&orientation=landscape',
    paragraphs: [
      '自开播以来，剧名一直是讨论的一部分。编剧在最新一次访谈中正面回应了这个话题。',
      '「我们写的不是越界，而是边界内的沉默。」他说，剧名里的「禁止」指的不是某段关系，而是这个家里所有人共同遵守的一条潜规则：有些事不能说。',
      '他透露，最初的故事大纲里并没有林小满这个角色，是在第三次修改时才加入的。「因为需要一个从外面回来的人，才能看见屋子里的裂缝。」',
      '谈到观众对结局的两种解读，他表示两者都成立。「如果看完之后你想到的是自己家里的某顿饭，那这部剧就算完成了它的任务。」',
    ],
    tags: ['编剧', '主题解读', '创作谈'],
  },
  {
    id: 6,
    title: '温以宁与沈知微的对手戏：两页纸的剧本拍了十四条',
    date: '2026-09-15',
    category: '幕后制作',
    summary: '第八集书房对峙戏的拍摄花絮公开，两位演员在开拍前进行了长达三小时的对词。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20behind%20the%20scenes%20moment%20of%20two%20actresses%20rehearsing%20at%20a%20wooden%20table%20in%20an%20old%20study%2C%20warm%20lamp%20light%2C%20deep%20crimson%20curtains%2C%20ivory%20walls%2C%20film%20monitor%20in%20soft%20focus%2C%20editorial%20documentary%20photography%2C%20no%20text%2C%20focused%20creative%20atmosphere&width=900&height=560&seq=news-06-scene&orientation=landscape',
    paragraphs: [
      '第八集书房对峙戏是全剧口碑最高的一段。最新公开的花絮显示，这场戏最终拍了十四条。',
      '导演在花絮中说，前六条两位演员的表演都很完整，但「太完整了」。「这场戏不应该像辩论，应该是两个人在互相试探底线，所以必须有停顿、有说错的话。」',
      '温以宁提到，两人在开拍前对词对了三个小时，把台词里所有没有写出来的部分都补了一遍。「我们知道苏婉和小满各自在害怕什么，剩下的就交给现场。」',
      '沈知微则说，最后采用的那一条里，她有一句台词说错了顺序，导演保留了这个错误。「因为那一刻小满确实已经乱了。」',
    ],
    tags: ['花絮', '对手戏', '幕后'],
  },
  {
    id: 7,
    title: '专题策划：顾家人物关系图，一次看懂十二条伏线',
    date: '2026-09-08',
    category: '专题策划',
    summary: '编辑部整理全剧人物关系与关键线索，梳理从第一集信件的出现到大结局门后留言的完整脉络。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20cinematic%20still%20life%20of%20connected%20vintage%20photographs%20and%20letters%20arranged%20on%20dark%20wood%2C%20deep%20crimson%20thread%20linking%20them%2C%20warm%20directional%20light%2C%20ivory%20paper%20tones%2C%20editorial%20conceptual%20photography%2C%20no%20text%2C%20elegant%20mystery%20mood&width=900&height=560&seq=news-07-relations&orientation=landscape',
    paragraphs: [
      '《禁止的爱善良的小姨子》用十二集讲了一个家庭的故事，却埋下了远多于十二集的细节。本篇专题从人物关系出发，梳理全剧的关键伏线。',
      '第一条线索是两封信。第一封从海外寄回，第二封藏在阁楼木箱，前者是邀请，后者是解释。两封信的出现顺序，正好对应小满对真相的接受程度。',
      '第二条线索是灯。客厅那盏灯从第一集到第十二集逐渐变亮，剧组用七个亮度档位完成了这条视觉暗线。',
      '第三条线索是那副多摆的碗筷。它只在第二集和第十一集出现过两次，却暗示了这个家一直在等待的人。',
      '更多细节仍在被观众陆续发现。可以确定的是，这部剧并不急着给答案，它更愿意把一个家摊开给你看。',
    ],
    tags: ['专题', '人物关系', '细节考据'],
  },
  {
    id: 8,
    title: '白露加盟特别篇？制作方回应：暂无可公布计划',
    date: '2026-08-30',
    category: '剧集动态',
    summary: '网络传出特别篇筹备消息，制作方表示目前专注于幕后特辑，暂无续作安排。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20moody%20still%20of%20an%20empty%20film%20set%20with%20a%20single%20chair%20and%20a%20standing%20lamp%2C%20deep%20red%20backdrop%2C%20ivory%20floor%2C%20soft%20haze%2C%20editorial%20atmospheric%20photography%2C%20no%20text%2C%20quiet%20suspenseful%20minimal%20composition&width=900&height=560&seq=news-08-rumor&orientation=landscape',
    paragraphs: [
      '近日有消息称，剧中沈曼一角的饰演者白露将参与一部特别篇的拍摄，引发观众期待。',
      '对此制作方回应称，目前团队的工作重心是即将上线的幕后特辑，暂无可公布的特别篇计划。「感谢大家的关注，一切以官方发布为准。」',
      '白露方面也通过工作人员表示，如果有合适的故事，她很愿意再次出演沈曼这个角色，「她身上还有很多没有说完的部分。」',
    ],
    tags: ['特别篇', '官方回应'],
  },
  {
    id: 9,
    title: '开播两周口碑观察：观众最在意的竟然是一顿饭',
    date: '2026-08-24',
    category: '观众热议',
    summary: '从弹幕与评论中整理出的高频关键词显示，「家宴」「碗筷」「厨房」成为讨论最多的场景。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20still%20life%20of%20a%20Chinese%20family%20dining%20table%20with%20several%20dishes%20and%20ivory%20bowls%2C%20soft%20evening%20light%2C%20deep%20crimson%20table%20runner%2C%20empty%20chair%2C%20editorial%20food%20photography%2C%20no%20text%2C%20nostalgic%20quiet%20atmosphere&width=900&height=560&seq=news-09-audience&orientation=landscape',
    paragraphs: [
      '开播两周后，围绕剧集的讨论逐渐从剧名转向内容。根据平台整理的高频关键词，「家宴」「碗筷」「厨房」出现的次数排在前列。',
      '第二集那场没有冲突的接风饭，成为观众提及最多的片段。有评论写道：「真正的紧张感不在吵架，而在谁先动筷子。」',
      '也有观众注意到剧中几乎每一顿饭都没有人吃完。「这大概是导演故意的，这个家始终没有真正坐下来好好吃一顿饭。」',
      '随着剧情推进，类似的细节讨论还在增加。对一部家庭题材剧来说，这或许比任何数据都更能说明问题。',
    ],
    tags: ['口碑', '观众', '细节'],
  },
];